(function () {
    const initCollapsibleContent = () => {
        $(".collapsible-content__toggle").unbind("click").on("click", function () {
            const parent = $(this).parent();
            const content = $(this).next();

            // Toggle the active class and slide the content
            parent.toggleClass("active");
            
            if (parent.hasClass("active")) {
                content.stop().slideDown(300);
            } else {
                content.stop().slideUp(300);
            }
        });

        // Mouse hover effects remain unchanged
        $(".collapsible-content__item").mouseenter(function (event) {
            $(this).removeClass("collapsible-content__item--opacity");
            $(this)
                .siblings()
                .addClass("collapsible-content__item--opacity");
            $(this).mouseleave(() => {
                $(this)
                    .siblings()
                    .removeClass("collapsible-content__item--opacity");
            });
        });
    };

    document.addEventListener("shopify:section:load", function () {
        initCollapsibleContent();
    });

    initCollapsibleContent();
})();